// extracted by mini-css-extract-plugin
export default {"user_menu":"Header_user_menu__hnkmX","main_logo":"Header_main_logo__+hu10","client_logo":"Header_client_logo__TOUTc","header":"Header_header__O3oaW"};